module.exports = __webpack_public_path__ + "img/top-jumbo3.3023c455.jpg";